export { default } from './Dialog';



// WEBPACK FOOTER //
// ./src/components/atoms/Dialog/index.js